import css from 'styled-jsx/css';
import { colors } from 'components/styles/variables';

const styles = css`
  .plus-icon-outer-container {
    height: 28px;
    width: 28px;
    border-radius: 4px;
    position: relative;
  }
  .plus-icon-outer-container:hover {
    background-color: ${colors.G1};
    cursor: pointer;
  }
  .plus-icon-inner-container {
    position: absolute;
    height: 16px;
    width: 16px;
    top: 6px;
    left: 6px;
  }
  .plus-icon {
    background-color: transparent;
    height: 16px;
    width: 16px;
  }
  .plus-icon:before,
  .plus-icon:after {
    content: '';
    position: absolute;
    background-color: ${colors.G3};
    transition: transform 0.25s ease-out;
  }
  .plus-icon:before {
    top: 0;
    left: 7px;
    width: 2px;
    height: 100%;
    border-radius: 1px;
  }
  .plus-icon:after {
    top: 7px;
    left: 0;
    width: 100%;
    height: 2px;
    border-radius: 1px;
  }
  .rotated:before {
    transform: rotate(-90deg);
  }
`;
export default styles;
